import spacetime from "spacetime";
/**
 * @param value
 * @return {boolean}
 */
export function isNumeric(value)
{
    const type= (typeof value);
    const isValidType = type === 'number' || type === 'string';
    if (! isValidType) {
        return false;
    }
    return ! isNaN(parseInt(value));
}
/**
 * @param {number} from
 * @param {number} to
 * @return {number[]}
 */
export function range(from, to)
{
    let range = [];
    for (let i = from; i <= to; i++) {
        range.push(i);
    }
    return range;
}
/**
 * @param {number[]} array
 * @return {number}
 */
export function sum(array)
{
    return array.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
}
/**
 * @return {spacetime}
 */
export function today()
{
    return spacetime.now().time('0:00am');
}
/**
 * Removes any keys that are not valid config values
 * @param configInstance {Object}
 * @param config {Object}
 */
export function filterOutNonConfigSettings(configInstance, config)
{
    const className = configInstance.constructor.name;
    Object.keys(config).forEach(configName => {
        if (configInstance[configName] === undefined) {
            console.error(`The config [${configName}] passed to the ${className} is not a valid setting`);
            delete config[configName];
        }
    });
}
/**
 * @param object {object}
 */
export function sortObjectByKeys(object) {
    const sortedKeys = Object.keys(object).sort();
    return sortedKeys.reduce((sortedObject, key) => {
        sortedObject[key] = object[key];
        return sortedObject;
    }, {});
}

/**
 * @param query {string}
 * @returns {Object}
 */
export function convertQueryStringToObject(query)
{
    query = query.substring(query.indexOf('?') + 1);
    const regex = /([^&=]+)=?([^&]*)/g;
    const decode = function (str) {
        return decodeURIComponent(str.replace(/\+/g, " "));
    };

    let params = {}, e;
    while (e = regex.exec(query)) {
        let k = decode(e[1]), v = decode(e[2]);
        if (k.substring(k.length - 2) === '[]') {
            k = k.substring(0, k.length - 2);
            (params[k] || (params[k] = [])).push(v);
        }
        else {
            params[k] = v
        };
    }

    const assign = function (obj, keyPath, value) {
        const lastKeyIndex = keyPath.length - 1;
        for (let i = 0; i < lastKeyIndex; ++i) {
            const key = keyPath[i];
            if (!(key in obj))
                obj[key] = {}
            obj = obj[key];
        }
        obj[keyPath[lastKeyIndex]] = value;
    }

    for (const prop in params) {
        const structure = prop.split('[');
        if (structure.length > 1) {
            let levels = [];
            structure.forEach(function (item) {
                const key = item.replace(/[?[\]\\ ]/g, '');
                levels.push(key);
            });
            assign(params, levels, params[prop]);
            delete(params[prop]);
        }
    }
    return params;
};


/**
 * @param obj {object}
 * @returns {string}
 */
export function convertObjectToUrlSearchParams(obj, prefix = '')
{
    let params = [];
    for (const key in obj)
    {
        const value = obj[key];
        const encodedKey = prefix ? `${prefix}[${encodeURIComponent(key)}]` : encodeURIComponent(key);

        if (Array.isArray(value)) {
            value.forEach(item => {
                params.push(`${encodedKey}[]=${encodeURIComponent(item)}`);
            });
        }
        else if (typeof value === 'object' && value !== null) {
            const nestedParams = convertObjectToUrlSearchParams(value, encodedKey);
            params.push(nestedParams);
        }
        else if (value !== undefined && value !== null) {
            params.push(`${encodedKey}=${encodeURIComponent(value)}`);
        }
    }

    return params.join('&');
}

/**
 * @returns {string}
 */
export function uuid() {

    if (window.crypto) {
        return window.crypto.randomUUID();
    }

    // fall back if window.crypto is not available
    let sequence = 0;
    const time = Date.now().toString(16);
    const rand = Math.floor(Math.random() * 10000).toString(16).padStart(4, '0');
    sequence = (sequence + 1) % 65536;
    const seq = sequence.toString(16).padStart(4, '0');
    return `${time}-${rand}-${seq}`;
}


/**
 * @param number {string}
 * @returns {string}
 */
export function getNumericTranslation(number)
{
    if (window.currentLocale === 'ar' || document.documentElement.lang === 'ar') {
        number = String(number).replace(/[0-9]/g, d => '٠١٢٣٤٥٦٧٨٩'[d]);
    }
    return number;
}